module.exports = __webpack_public_path__ + "static/media/loader2.164d3e03.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader2.gif
// module id = ./src/assets/img/loader2.gif
// module chunks = 11